// Overrides the backend INSTALLATION_NAME in the UI layer (D-01: backend untouched)
export const BRAND_NAME = 'Bnar';
